import classNames from 'classnames';
import type { MutableRefObject } from 'react';
import { useCallback } from 'react';
import { useHiddenOptions } from 'shared/ui/MultiSelect/Hooks/useHiddenOptions';

interface HidableChipProps {
  children: React.ReactNode;
  selectedOptionsLength: number;
  parentRef: MutableRefObject<HTMLButtonElement | null>;
  id: string;
  gutterWidth?: number;
  onHide?: (id: string, hidden: boolean) => void;
  isFirst: boolean;
}

export function HidableOption(props: HidableChipProps) {
  const { children, parentRef, selectedOptionsLength, onHide, id, gutterWidth, isFirst } = props;

  const handleHide = useCallback(
    (hidden: boolean) => {
      onHide && onHide(id, hidden);
    },
    [onHide, id]
  );

  const { optionIsHidden, optionRef } = useHiddenOptions({
    isFirst,
    parentRef,
    gutterWidth,
    selectedOptionsLength,
    onHide: handleHide,
  });

  return (
    <span
      ref={optionRef}
      className={classNames(optionIsHidden ? 'invisible' : 'visible')}
    >
      {children}
    </span>
  );
}
